"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dingbatsUnicodeChart = {
    "33": "✁",
    "34": "✂",
    "35": "✃",
    "36": "✄",
    "37": "☎",
    "38": "✆",
    "39": "✇",
    "40": "✈",
    "41": "✉",
    "42": "☛",
    "43": "☞",
    "44": "✌",
    "45": "✍",
    "46": "✎",
    "47": "✏",
    "48": "✐",
    "49": "✑",
    "50": "✒",
    "51": "✓",
    "52": "✔",
    "53": "✕",
    "54": "✖",
    "55": "✗",
    "56": "✘",
    "57": "✙",
    "58": "✚",
    "59": "✛",
    "60": "✜",
    "61": "✝",
    "62": "✞",
    "63": "✟",
    "64": "✠",
    "65": "✡",
    "66": "✢",
    "67": "✣",
    "68": "✤",
    "69": "✥",
    "70": "✦",
    "71": "✧",
    "72": "★",
    "73": "✩",
    "74": "✪",
    "75": "✫",
    "76": "✬",
    "77": "✭",
    "78": "✮",
    "79": "✯",
    "80": "✰",
    "81": "✱",
    "82": "✲",
    "83": "✳",
    "84": "✴",
    "85": "✵",
    "86": "✶",
    "87": "✷",
    "88": "✸",
    "89": "✹",
    "90": "✺",
    "91": "✻",
    "92": "✼",
    "93": "✽",
    "94": "✾",
    "95": "✿",
    "96": "❀",
    "97": "❁",
    "98": "❂",
    "99": "❃",
    "100": "❄",
    "101": "❅",
    "102": "❆",
    "103": "❇",
    "104": "❈",
    "105": "❉",
    "106": "❊",
    "107": "❋",
    "108": "●",
    "109": "❍",
    "110": "■",
    "111": "❏",
    "112": "❐",
    "113": "❑",
    "114": "❒",
    "115": "▲",
    "116": "▼",
    "117": "◆",
    "118": "❖",
    "119": "◗",
    "120": "❘",
    "121": "❙",
    "122": "❚",
    "123": "❛",
    "124": "❜",
    "125": "❝",
    "126": "❞",
    "161": "❡",
    "162": "❢",
    "163": "❣",
    "164": "❤",
    "165": "❥",
    "166": "❦",
    "167": "❧",
    "168": "♣",
    "169": "♦",
    "170": "♥",
    "171": "♠",
    "172": "①",
    "173": "②",
    "174": "③",
    "175": "④",
    "176": "⑤",
    "177": "⑥",
    "178": "⑦",
    "179": "⑧",
    "180": "⑨",
    "181": "⑩",
    "182": "❶",
    "183": "❷",
    "184": "❸",
    "185": "❹",
    "186": "❺",
    "187": "❻",
    "188": "❼",
    "189": "❽",
    "190": "❾",
    "191": "❿",
    "192": "➀",
    "193": "➁",
    "194": "➂",
    "195": "➃",
    "196": "➄",
    "197": "➅",
    "198": "➆",
    "199": "➇",
    "200": "➈",
    "201": "➉",
    "202": "➊",
    "203": "➋",
    "204": "➌",
    "205": "➍",
    "206": "➎",
    "207": "➏",
    "208": "➐",
    "209": "➑",
    "210": "➒",
    "211": "➓",
    "212": "➔",
    "213": "→",
    "214": "↔",
    "215": "↕",
    "216": "➘",
    "217": "➙",
    "218": "➚",
    "219": "➛",
    "220": "➜",
    "221": "➝",
    "222": "➞",
    "223": "➟",
    "224": "➠",
    "225": "➡",
    "226": "➢",
    "227": "➣",
    "228": "➤",
    "229": "➥",
    "230": "➦",
    "231": "➧",
    "232": "➨",
    "233": "➩",
    "234": "➪",
    "235": "➫",
    "236": "➬",
    "237": "➭",
    "238": "➮",
    "239": "➯",
    "241": "➱",
    "242": "➲",
    "243": "➳",
    "244": "➴",
    "245": "➵",
    "246": "➶",
    "247": "➷",
    "248": "➸",
    "249": "➹",
    "250": "➺",
    "251": "➻",
    "252": "➼",
    "253": "➽",
    "254": "➾"
};
function isDingbatCharacter(x) {
    return exports.dingbatsUnicodeChart.hasOwnProperty(x);
}
exports.isDingbatCharacter = isDingbatCharacter;
exports.translateCharToDingbat = function (char) { return isDingbatCharacter(char) ? exports.dingbatsUnicodeChart[char] : undefined; };
//# sourceMappingURL=dingbats.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/latex-to-unicode-converter/ts-compiled/unicode/commands/1args/symbols/dingbats.js
// module id = 130
// module chunks = 0 1 2 3